module.exports = __webpack_public_path__ + "img/biaoqian_shipinjiankong.c9b3230f.png";